module.exports = __webpack_public_path__ + "img/good1.841626dd.png";